export const deepCopy = function (inObject) {
  let outObject, value, key
    
  if (typeof inObject !== 'object' || inObject === null) {
    return inObject
  }
    
  outObject = Array.isArray(inObject) ? [] : {}
    
  for (key in inObject) {
    value = inObject[key]
    
    outObject[key] = deepCopy(value)
  }
    
  return outObject
}

export function setCurrentApplicationName(name) {
  window.CurrentApplicationName = name
}
export function getApplicationName() {
  return 'v:' + window.CurrentApplicationName
}